import { render, staticRenderFns } from "./CompositeDetail.vue?vue&type=template&id=454b4d84&scoped=true"
import script from "./CompositeDetail.vue?vue&type=script&lang=js"
export * from "./CompositeDetail.vue?vue&type=script&lang=js"
import style0 from "./CompositeDetail.vue?vue&type=style&index=0&id=454b4d84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b4d84",
  null
  
)

export default component.exports